<template>
  <div
    style="height: calc(100vh); overflow:auto;"
    class="mm"
  >
  <v-layout 
    v-if="activities"
    wrap 
    class="activity-page"
    :style=" { width: width }"
  >
    <v-flex xs12 class="header">
      <!--span :style="{ color: color2 }">{{ titleDate }}</span><span :style="{ color: color1 }"> - {{ titleInfo }}</span-->
      <span :style="{ color: color2 }">{{ titleDate }}</span><span :style="{ color: color1 }"></span>
    </v-flex>
    <v-flex
      v-bind:class="{ [display]: true }"
      v-for="(activityItem, index) of activities"
      :key="index"
      style="padding: 20px;"
    >
      <activity-item-banner-scroll
        :data="activityItem"
        :color1="color1"
        :color2="color2"
        :color3="color3"
        :color4="color4"
      />
    </v-flex>
    <div :style="{height: `${marginBottom}px` }" />
  </v-layout>
  </div>
</template>

<script>
import utils from '@/services/utils'
import ActivityItemBannerScroll from '../activityItemBannerScroll/Index'
export default {
  name: 'ActivityPageBannerScroll',
  components: {
    ActivityItemBannerScroll,
  },
  props: {
    titleDate: {
      type: String,
      default: null
    },
    titleInfo: {
      type: String,
      default: null
    },
    activities: {
      type: Array,
      default: null
    },
    cols: {
      type: Number,
      default: 2
    },
    color1: {
      type: String,
      default: '#02443C'
    },
    color2: {
      type: String,
      default: '#BF9D5A'
    },
    color3: {
      type: String,
      default: '#BF9D5A'
    },
    color4: {
      type: String,
      default: '#BF9D5A'
    },
    width: {
      type: Number,
      default: 1920,
    },
  },
  data: () => ({
    interval: 50,
    t: null,
  }),
  computed: {
    display () {
      return `xs${12/this.cols}`
    },
    marginBottom () {
      const aux = utils.getParameterByName('mb')
      return aux ? aux | 0 : 0
    },
  },
  mounted () {
    this.prepareTime ()
    /*
    //console.log(document.body.scrollHeight)
    //window.scrollTo(0, document.body.scrollHeight)
    const that = this
    setTimeout(() => {
      that.pageScroll()
    //console.log(document.body.scrollHeight)
    //window.scrollTo(0, document.body.scrollHeight)
    }, 1000)
    */
  },
  methods: {
    async prepareTime () {
      const segScreen = 30

      let milisegundos = segScreen * 1000
      milisegundos = milisegundos / this.interval
      // $heightEvents = (count($dates) * 164) + 100;
      const heightEvents = this.activities.length * 164
      this.t = heightEvents / milisegundos
      this.t = this.t >= 1 ? this.t : 0

      await new Promise(r => setTimeout(r, 2000))
      this.pageScroll()
    },
    async pageScroll() {
      const that = this
      const e = document.querySelector('.mm')
      e.scrollTop = 0
      window.setInterval(() => {
        e.scrollTop = e.scrollTop + that.t
        },  that.interval)
        /*
      window.scrollBy(0, 1)
      setTimeout(this.pageScroll, 10)
      */
    },
  },
}
</script>

<style scoped>
.activity-page {
  margin: 0;
  padding: 0 20px;
}

.header {
  padding: 50px 10px;
  font-size: 40px;
  line-height: 40px;
  height: 130px;
  font-weight: 500;
}
.mm {
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}

.mm::-webkit-scrollbar {
  display: none; /* For WebKit browsers */
}
</style>

